import { useNavigate } from "react-router-dom";
import CashflowApp from "../components/CashflowApp";

export default function Cashflow() {
  const navigate = useNavigate();

  return (
    <div>
      {/* Portfolio nav bar */}
      <div style={{
        position: "fixed",
        top: 0, left: 0, right: 0,
        zIndex: 9999,
        background: "rgba(8,8,8,0.92)",
        backdropFilter: "blur(12px)",
        borderBottom: "1px solid rgba(255,255,255,0.06)",
        padding: "10px 24px",
        display: "flex",
        alignItems: "center",
        gap: 20,
      }}>
        <button
          onClick={() => navigate("/")}
          style={{
            background: "none",
            border: "1px solid rgba(255,255,255,0.12)",
            color: "#94A3B8",
            padding: "6px 16px",
            borderRadius: 6,
            cursor: "pointer",
            fontSize: 12,
            letterSpacing: 2,
            fontFamily: "'Georgia', serif",
            textTransform: "uppercase",
          }}
        >
          ← Portfolio
        </button>
        <div style={{ fontSize: 11, color: "#3A3530", letterSpacing: 3, textTransform: "uppercase" }}>
          projectsbyjosiah.com / cashflow
        </div>
      </div>

      {/* Offset content below fixed nav */}
      <div style={{ paddingTop: 48 }}>
        <CashflowApp />
      </div>
    </div>
  );
}
